import React from 'react';
import ReactDOM from 'react-dom';
import { isIE } from 'react-device-detect';
import App from './App';
import { Result } from 'antd';
import { isMaintenanceMode } from './utils';


const node = document.getElementById('root');

switch (true) {
    case isIE:
        ReactDOM.render(
            <Result
                status="500"
                title="Sorry! We currently don't support this browser"
                subTitle="To use our online booking for, you need to use a modern browser: the latest versions of Chrome, Firefox, Safari and Edge are supported."
            />,
            node
        );
        break;
    case isMaintenanceMode():
        ReactDOM.render(
            <Result
                status="500"
                title="Be back soon!"
                subTitle="Site currently under maintenance."
            />,
            node
        );
        break;
    default:
        ReactDOM.render(
            <App/>,
            node
        );
}
